/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_DescriptionInputs */

const en_minifier_description = /** @type {(inputs: Minifier_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minify JSON by removing whitespace. Reduce JSON file size for production use.`)
};

const ko_minifier_description = /** @type {(inputs: Minifier_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공백을 제거하여 JSON을 압축하세요. 프로덕션용으로 JSON 파일 크기를 줄입니다.`)
};

const ja_minifier_description = /** @type {(inputs: Minifier_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白を削除してJSONを圧縮。本番用にJSONファイルサイズを削減します。`)
};

/**
* | output |
* | --- |
* | "Minify JSON by removing whitespace. Reduce JSON file size for production use." |
*
* @param {Minifier_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_description = /** @type {((inputs?: Minifier_DescriptionInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_DescriptionInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_description(inputs)
	if (locale === "ko") return ko_minifier_description(inputs)
	return ja_minifier_description(inputs)
});